import "./ScaffoldingInHighWycombe.module.css";
import Header from "@/reusable_sections/Header";
import WycombeHero from "./sections/WycombeHero";
import Highwycombe from "./sections/Highwycombe";
import WycombeCoverage from "./sections/WycombeCoverage";
import WycombeSafety from "./sections/WycombeSafety";
import WycombeFaq from "./sections/WycombeFaq";
import FinalCta from "./sections/FinalCta";
import Footer from "@/reusable_sections/Footer";
export default function ScaffoldingInHighWycombePage() {
  return <div>
      <Header />
      <WycombeHero />
      <Highwycombe />
      <WycombeCoverage />
      <WycombeSafety />
      <WycombeFaq />
      <FinalCta />
      <Footer />
    </div>;
}